import { combineReducers } from 'redux'
import commonDucks from './commonDucks'
import menuDucks from './menuDucks'
import userDucks from './userDucks'
import customerDucks from './customerDucks'
import orderDucks from './orderDucks'
import shipmentDucks from './shipmentDucks'
import containerDucks from './containerDucks'
import auditDucks from './auditDucks'
import hoaDonPosDucks from './hoaDonPosDucks'

const rootReducer = combineReducers({
  common: commonDucks,
  menu: menuDucks,
  user: userDucks,
  customer: customerDucks,
  order: orderDucks,
  shipment: shipmentDucks,
  container: containerDucks,
  audit: auditDucks,
  hoaDonPos: hoaDonPosDucks,
})

export default rootReducer
